export default __webpack_public_path__ + "static/media/joachim.0f6589a7.png";